import React from 'react';

const solutions = [
  {
    iconClass: 'fas fa-chart-line',
    title: 'Apache Superset',
    description:
      'Real-time Analytics Solution for comprehensive data visualization and business intelligence.',
    tags: ['Analytics', 'Real-time'],
  },
  {
    iconClass: 'fas fa-chart-bar',
    title: 'Power BI',
    description:
      "Microsoft's powerful data analytics solution for interactive visualizations and business insights.",
    tags: ['Microsoft', 'Visualization'],
  },
  {
    iconClass: 'fas fa-hands-helping',
    title: 'Consultancy Services',
    description:
      'Expert guidance to help you make the most of your data and technology investments.',
    tags: ['Expert Guidance', 'Strategy'],
  },
  {
    iconClass: 'fas fa-chart-pie',
    title: 'Tableau',
    description:
      'Interactive data visualization software focused on business intelligence.',
    tags: ['Visualization', 'Business Intelligence'],
  },
  {
    iconClass: 'fas fa-brain', // or 'fas fa-robot' / 'fas fa-microchip' — 'fa-brain' gives a stronger AI/ML feel
    title: 'AI & Machine Learning Integration',
    description:
      'AI-powered solutions that integrate seamlessly into your systems to automate processes, enhance decision-making, and deliver predictive insights.',
    tags: ['AI', 'Machine Learning', 'Automation'],
  },

  {
    iconClass: 'fas fa-brain', // Classic data engineering icon; alternatives: 'fas fa-server', 'fas fa-cogs', 'fas fa-stream'
    title: 'Data Engineering',
    description:
      'Building reliable data pipelines, warehouses, and integration workflows that ensure clean, structured, and analytics-ready data.',
    tags: ['Data Pipelines', 'ETL', 'SQL', 'Cloud Data'],
  },
];

export const Gallery = (props) => {
  return (
    <section
      id="portfolio"
      style={{
        marginTop: '60px',
        position: 'relative',
        width: '100%',
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `url('https://img.freepik.com/free-photo/successful-businessmen-seal-deal-with-firm-handshake-generated-by-ai_188544-40065.jpg?uid=R139167315&ga=GA1.1.821665019.1742142147&semt=ais_hybrid&w=740') center center/cover no-repeat`,
        borderRadius: '16px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0,0,0,0.7)',
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          color: '#fff',
          textAlign: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '60px 20px',
          width: '100%',
        }}
      >
        <div style={{ marginBottom: '40px' }}>
          <h3
            style={{
              fontSize: '3.5rem',
              fontWeight: 700,
              marginBottom: '15px',
              position: 'relative',
              display: 'inline-block',
              color: 'white',
            }}
          >
            Ready-to-Market Solutions
            <span
              style={{
                content: '',
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '60px',
                height: '4px',
                background: '#2563eb',
                borderRadius: '2px',
              }}
            ></span>
          </h3>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px',
            marginTop: '30px',
          }}
        >
          {solutions.map((sol, idx) => (
            <div
              key={idx}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
                padding: '25px 20px',
                transition: 'all 0.3s ease',
                textAlign: 'left',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <i
                className={sol.iconClass}
                style={{
                  fontSize: '2rem',
                  color: 'transparent',
                  backgroundImage: 'linear-gradient(135deg, #2563eb, #7e22ce)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  marginBottom: '15px',
                  display: 'inline-block',
                }}
              ></i>
              <h4
                style={{
                  fontSize: '2.0rem',
                  fontWeight: 600,
                  marginBottom: '12px',
                  color: '#fff',
                }}
              >
                {sol.title}
              </h4>
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: '1.25rem',
                  marginTop: 'auto',
                }}
              >
                {sol.description}
              </p>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '8px',
                  marginTop: '15px',
                }}
              >
                {sol.tags.map((tag, tagIdx) => (
                  <span
                    key={tagIdx}
                    style={{
                      background: 'rgba(37, 99, 235, 0.2)',
                      color: '#fff',
                      padding: '4px 10px',
                      borderRadius: '20px',
                      fontSize: '0.95rem',
                      fontWeight: 500,
                      border: '1px solid rgba(37, 99, 235, 0.3)',
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <button
          style={{
            display: 'inline-block',
            marginTop: '40px',
            padding: '12px 30px',
            background: 'linear-gradient(90deg, #2563eb, #7e22ce)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '30px',
            fontWeight: 600,
            transition: 'all 0.3s ease',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          }}
        >
          Explore All Solutions
        </button>
      </div>
    </section>
  );
};
